import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

import { getButtonClassName } from './helpers';
import { TestID } from './constants';

export interface Props {
  disabled: boolean;
  onClick: () => void;
  submitting: boolean;
}

const ScheduleButton: React.FC<Props> = ({ disabled, onClick, submitting }) => (
  <button
    className={getButtonClassName({ isDisabled: disabled })}
    data-testid={TestID}
    disabled={disabled}
    onClick={onClick}
  >
    {submitting && (
      <CircularProgress
        size={17}
        style={{
          color: '#FFF',
        }}
      />
    )}

    {!submitting && 'Schedule'}
  </button>
);

export default ScheduleButton;
